import { z } from 'zod';
const createOrgDetailsFormModelSchema = z.object({
  name: z.string(),
  industry: z.string()
});

export type CreateOrgDetailsFormModel = z.infer<typeof createOrgDetailsFormModelSchema>;

export const isCreateOrgDetailsFormModel = (model: unknown): model is CreateOrgDetailsFormModel => {
  return createOrgDetailsFormModelSchema.safeParse(model).success;
};

const addOrgTeamMemberFormModelSchema = z.record(z.string(), z.string());
export type AddOrgTeamMemberFormModel = z.infer<typeof addOrgTeamMemberFormModelSchema>;

export const isTeamMemberFormModel = (model: unknown): model is AddOrgTeamMemberFormModel => {
  return addOrgTeamMemberFormModelSchema.safeParse(model).success;
};

export const validateTeamMemberFormModelForEmails = (model: unknown) => {
  const parsedModel = addOrgTeamMemberFormModelSchema.safeParse(model);
  if (parsedModel.success) {
    const teamMemberEmails = Object.values(parsedModel.data);
    return teamMemberEmails.every(email => z.string().email().safeParse(email).success);
  }
  return false;
}

export const createOrgRequestModelSchema = z.object({
  name: z.string(),
  industry: z.string(),
  teamMembers: z.array(z.string().email())
});

export type CreateOrgRequestModel = z.infer<typeof createOrgRequestModelSchema>;

export const mapToCreateOrgRequestModel = (
  model: CreateOrgDetailsFormModel,
  teamMembers: AddOrgTeamMemberFormModel = {}
): CreateOrgRequestModel => {
  const teamMemberEmails = Object.values(teamMembers).filter(email => !!email);
  return {
    name: model.name,
    industry: model.industry,
    teamMembers: teamMemberEmails
  };
};


